export function setgridheight(container, gridInitialInit) {

  console.log('setgridheight - grid-helpers.js');
  let gridWrap,
    sidegrid;

    console.log("container", container);
  if (container === document.querySelector('main')) {
    console.log("container is main - default behaovior");
    gridWrap = document.getElementById('grid');
    sidegrid = null;
  } else {
    console.log("container is not main - side grid behavior", container);
    gridWrap = null;
    // const gridWrap = container.querySelector('.grid__container');
    sidegrid = container;//.querySelector('.side-grid-container');
  }

  console.log("gridWrap", gridWrap);
  console.log("container", container);
  console.log("sidegrid", sidegrid);

  let baselinesGrid,
    linesGrid,
    isoGrid,
    colGrid,
    rowGrid;

  // Check if gridWrap exists before proceeding
  if (sidegrid !== null) {
      console.log("sidegrid", sidegrid);
      baselinesGrid = sidegrid.querySelector('.grid__baselines');
      linesGrid = sidegrid.querySelector('.grid__vertlines');
      isoGrid = sidegrid.querySelector('.grid__iso');
      colGrid = sidegrid.querySelector('.grid__columns');
      rowGrid = sidegrid.querySelector('.grid__rows');

    // Ensure all necessary elements exist
    if (!baselinesGrid || !linesGrid || !isoGrid || !colGrid || !rowGrid) {
      console.warn('IN Sidegrid One or more grid elements not found, exiting function');
      return;
    }

    // return
  } else if (gridWrap !== null) {
  
    console.log("gridWrap", gridWrap);

      baselinesGrid = gridWrap.querySelector('.grid__baselines');
      linesGrid = gridWrap.querySelector('.grid__vertlines');
      isoGrid = gridWrap.querySelector('.grid__iso');
      colGrid = gridWrap.querySelector('.grid__columns');
      rowGrid = gridWrap.querySelector('.grid__rows');

    // Ensure all necessary elements exist
    if (!baselinesGrid || !linesGrid || !isoGrid || !colGrid || !rowGrid) {
      console.warn('IN Gridwrap One or more grid elements not found, exiting function');
      return;
    }

  } else if (!gridWrap) {
    console.warn('Grid wrapper not found, exiting function');
    return
  }



  const unitWidthValue = 12, // width of 1 isometric unit
    lineHeightRatio = 1.1547005, // real ratio: 1.1547005
    lineHeight = lineHeightRatio * unitWidthValue,
    rowHeight = lineHeight * 4;

    if (gridWrap) {
      gridWrap.style.height = "0";
    } else if (sidegrid) {
      // sidegrid.style.height = "0";s
    }


  const siteContentHeight = container.offsetHeight,
    rowsQuantity = Math.ceil(siteContentHeight / rowHeight),
    baselinesQuantity = Math.ceil(siteContentHeight / lineHeight),
    colsQuantity = 7,
    linesQuantity = colsQuantity * 12,
    linesSidesQuantity = linesQuantity / 2;

    if (gridWrap) {
      gridWrap.style.height = `${siteContentHeight}px`;
    } else if (sidegrid) {
      //height is based on the container - reivew f this neded
    }

  function setGridSizes(gridInitialInit, quantity, type) {
    if (type === "col-grid") {
      if (!gridInitialInit) {
        const leftCol = colGrid.querySelector(".grid__columns-left"),
          rightCol = colGrid.querySelector(".grid__columns-right");

        if (leftCol && rightCol) {
          for (let i = 1; i < quantity; i++) {
            rightCol.insertAdjacentHTML('beforeend', `<div class='grid__column grid__column-right grid__column-right-${i} grid__column-${i}'><div class='grid__column-inner'><div class='grid__column-inside'></div></div></div>`);
            leftCol.insertAdjacentHTML('beforeend', `<div class='grid__column grid__column-left grid__column-left-${i} grid__column-${i}'><div class='grid__column-inner'><div class='grid__column-inside'></div></div></div>`);
          }
        }
      }
    } else if (type === "row-grid") {
      if (gridInitialInit) rowGrid.innerHTML = '';
      rowGrid.insertAdjacentHTML('beforeend', new Array(quantity + 1).join('<div class="grid__row"></div>'));
    } else if (type === "iso-grid") {
      if (gridInitialInit) isoGrid.innerHTML = '';
      isoGrid.insertAdjacentHTML('beforeend', new Array(quantity + 1).join('<div class="grid__iso-baseline"></div>'));
    } else if (type === "baseline-grid") {
      if (gridInitialInit) baselinesGrid.innerHTML = '';
      baselinesGrid.insertAdjacentHTML('beforeend', new Array(quantity + 1).join('<div class="grid__baseline"></div>'));
    } else if (type === "lines-grid") {
      if (!gridInitialInit) {
        const leftLines = linesGrid.querySelector(".grid__vertlines-left"),
          rightLines = linesGrid.querySelector(".grid__vertlines-right");

        if (leftLines && rightLines) {
          leftLines.insertAdjacentHTML('beforeend', new Array(quantity + 1).join('<div class="grid__vertline grid__vertline-left"></div>'));
          rightLines.insertAdjacentHTML('beforeend', new Array(quantity + 1).join('<div class="grid__vertline grid__vertline-right"></div>'));
        }
      }
    }
  }

  setGridSizes(gridInitialInit, colsQuantity, 'col-grid');
  setGridSizes(gridInitialInit, rowsQuantity, 'row-grid');
  setGridSizes(gridInitialInit, baselinesQuantity, 'iso-grid');
  setGridSizes(gridInitialInit, baselinesQuantity, 'baseline-grid');
  setGridSizes(gridInitialInit, linesSidesQuantity, 'lines-grid');

  console.log('END setgridheight - grid-helpers.js');
}